import { dataService } from "../services/data.services";
import { userService } from "../services/user.services";


export const CheckUserStatus = async()=>{

    let user=true;

    //const user1 =  await userService.getUserData()
    try {
        const user1 = await dataService.GetAPI('users/check-status');
       
        localStorage.setItem('custom-status', user1?.data?.data?.user_status);
        if (user1?.data?.data?.user_status==='inactive') {
            const browserIdValue = localStorage.getItem('arcm_trust_browser_token');
            // User is deactivated, log out the user
            user=false;
            await userService.logout()
            sessionStorage.clear();
            localStorage.setItem('custom-status', 'inactive');
            localStorage.setItem('arcm_trust_browser_token', browserIdValue);
            setTimeout(() => {
                window.location.reload();
            }, 500);
        } 
    }catch (e) {
        console.log("error from checkuser status",e)
    }
    return user

}
   

        

    





